import { defineStore } from 'pinia'
import { reportService } from '@/services/reportService'
import errorService from '@/services/errorService';

export const useReportStore = defineStore('report', {
  state: () => ({
    articles: {
      data: {},
      meta: {},
      page: {},
      chart: null,
    },
    articlePages: {
      meta: {}
    },
    article: {},
    filter: {},
    pages: {
      data: {},
      meta: {}
    }
  }),

  actions: {
    async getArticles(params, cancelToken) {
      try {
        const response = await reportService.fetchArticles(params, cancelToken);
        this.articles = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticle(id) {
      try {
        const response = await reportService.fetchArticle(id);
        this.article = response.data.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticlePages(id, params) {
      try {
        const response = await reportService.fetchArticlePages(id, params);
        this.articlePages = response.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPages(params) {
      try {
        const response = await reportService.fetchPages(params);
        this.pages = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPage(id, params) {
      try {
        const response = await reportService.fetchPage(id, params);
        this.articles = response.data;

      } catch (error) {
        return errorService.handle(error);
      }
    },
  }
});